import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Maps the names the hand-written stylesheets already use onto the one token
// set emitted from theme.js. See src/styles/tokens.css.
import './styles/tokens.css';
// How every sidebar behaves below the desktop breakpoint — see the file.
import './styles/rails.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { API_BASE } from './utils/api';

// 1. Import ThemeProvider and your custom theme
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline, GlobalStyles } from '@mui/material';
import theme, { cssVariables } from './theme'; // Your custom theme file

const root = ReactDOM.createRoot(document.getElementById('root'));
// One-time boot log to confirm what backend URL the app will use
console.log('[BOOT] API_BASE =', API_BASE);
// 2. Wrap your App with ThemeProvider and CssBaseline
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Normalizes styles and applies background */}
      {/* 3. Publish the same design tokens as CSS custom properties, so the
          hand-written stylesheets can read the values the theme holds.
          Nothing consumes these yet — Phase 3 points the stylesheets at them. */}
      <GlobalStyles styles={{ ':root': cssVariables() }} />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

reportWebVitals();